import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { PENDING } from '../../../store/globalStatuses/globalStatuses';

import styles from './fillForm.module.scss';
import exclaimImg from 'assets/exclaim.png';

import { useDispatch, useSelector } from 'react-redux';
import ButtonFilled from "../../FormElements/ButtonFilled";
import transactionsActions from "../../../store/transactionsStore/transactionsActions";
import { store } from "react-notifications-component";
import TransactionsTypes from "../../../store/transactionsStore/transactionsTypes";
import { CustomSingleDatePicker } from "../../CustomDatePicker/CustomDatePicker";
import { convertDate } from "../../../tools/convertDateToString";
import clientsApi from "../../../store/clientsStore/clientsApi";
import clientInfoTypes from "../../../store/clientInfoStore/clientInfoTypes";

const RESTRICTED_TAG_BUSINESS_IDS = ["1990319019407708160", "2024707981702074368", "2024709367416229888", "1990320835134492672", "2034216763209551872", "2034213686763065344", "2037054083965128704"];
const SMS_CODE_BUSINESS_IDS = ["2024707981702074368", "2024709367416229888", "2034216763209551872", "2037054083965128704"];

export default function FillForm(props) {
  const {
    isSendUseCashbackCodePending,
    isSendedUseCashbackCode,
    phone,
    customer,
    setStep,
    amount_sum,
    bonuses,
    changeAmountSum,
    changeBonuses,
    comment,
    payment,
    setPayment,
    changeComment,
    getClientCashback,
    add_stamp,
    give_award,
    changeAward,
    changeStamp,
    info,
    notRegistered,
    getClientAward,
    type,
    stamp_count,
    changeStampCount,
    cStatus,
    selectedTag,
    setSelectedTag,
    userTags,
    branchTags,
    isDiscountOrder,
    setIsDiscountOrder,
    userSubscriptions,
    selectedSubscription,
    setSelectedSubscription,
    childBirthdays,
    childBirthdaysPending,
    addChildBirthday,
    deleteChildBirthday,
    selectedUserTagId,
    setSelectedUserTagId,
  } = props;

  // Check if this business requires SMS code instead of WhatsApp code
  const isSmsCodeBusiness = info && info.id && SMS_CODE_BUSINESS_IDS.includes(info.id.toString());

  // Check if client has any discount tag
  const hasDiscountTag = userTags && userTags.some(tag => tag.is_discount);
  const isRestrictedTagBusiness = info && info.id && RESTRICTED_TAG_BUSINESS_IDS.includes(info.id.toString());

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [error, setError] = useState(false);

  const [loading, setLoading] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [birthday, setBirthday] = useState(null);

  const [awardId, setAwardId] = useState(customer.award_id);
  const [useTalon, setUseTalon] = useState(false);
  const [newChildBirthday, setNewChildBirthday] = useState('');
  const [showAddChildBirthday, setShowAddChildBirthday] = useState(false);

  const { aStatus } = useSelector(state => state.clientInfoReducer);
  const { pending } = useSelector(state => state.branchReducer);

  const availableBonusesForWithdraw = (() => {
    const pct = info.configuration.private_cashback.access_withdraw_bonus_percentage;
    if (!pct) return 0;
    if (info.configuration.private_cashback.access_withdraw_bonus_type === 'FROM_PRIVATE_BALANCE_AMOUNT') {
      return Math.floor(Math.min(customer.bonuses * pct / 100, amount_sum));
    }
    return Math.floor(Math.min(amount_sum * pct / 100, customer.bonuses));
  })();

  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  useEffect(() => {
    if (customer) {
      setFirstName(customer.first_name || "");
      setLastName(customer.last_name || "");
      let d = null;
      if (customer.birthday) {
        const splitted = customer.birthday.split("-");
        d = `${splitted[2]}-${splitted[1]}-${splitted[0]}`;
      }
      if (isValidDate(new Date(d))) {
        setBirthday(d);
      } else {
        setBirthday(null);
      }
    }
  }, [customer]);

  useEffect(() => {
    getClientCashback(amount_sum);
  }, [customer]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (amount_sum) {
        getClientCashback(amount_sum);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [amount_sum]);

  useEffect(() => {
    setAwardId(customer.award_id);

    if (info.configuration.award && info.configuration.access_toggles.awards && info.configuration.access_toggles.awards.enabled && customer.id) {
      if (!customer.received_stamp_count || !customer.expired_at || !customer.award_id) {
        if (!awardId || awardId !== customer.award_id) {
          getClientAward();
        }
      }
    }
  }, [customer, info]);

  // Auto-select first discount tag when user has discount tags (restricted businesses only)
  useEffect(() => {
    if (isRestrictedTagBusiness && userTags && userTags.length > 0) {
      const firstDiscountTag = userTags.find(tag => tag.is_discount);
      if (firstDiscountTag) {
        setSelectedUserTagId(firstDiscountTag.id.toString());
        setSelectedTag(null);
        setIsDiscountOrder(true);
      }
    }
  }, [userTags, isRestrictedTagBusiness]);


  const getHalfOfBonuses = () => {
    if (notRegistered || !customer.bonuses) return
    const bonuses = Math.floor(customer.bonuses);

    if (parseInt(amount_sum) < Math.ceil(bonuses / 2) && amount_sum.length !== 0) {
      return changeBonuses(amount_sum)
    }

    changeBonuses(Math.ceil( bonuses / 2))
  }

  const getAllBonuses = () => {
    if (notRegistered || !customer.bonuses) return
    const bonuses = Math.floor(customer.bonuses);
    if (parseInt(amount_sum) < bonuses && amount_sum.length !== 0) {
      changeBonuses(amount_sum)
    } else {
      changeBonuses(Math.floor(bonuses))
    }
  }

  const nextStep = () => {
    let newB = null;
    if (birthday) {
      newB = convertDate(birthday).split('.').join('-')
    }

    if (notRegistered) {
      if(isNaN(parseInt(amount_sum))) {
        setError(true);
        return;
      }

      setLoading(true);
      clientsApi.putClient('undefined', { phone_number: '+'+phone, first_name: firstName, last_name: lastName, birthday: newB, branch_id: info?.id })
        .then((customer) => {
          dispatch({ type: clientInfoTypes.UPDATE_CLIENT_INFO, payload: customer.data });
          setError(false);
          setStep(3);
        })
        .finally(() => {
          setLoading(false);
        })
      return
    }

    // When using talon (subscription stamp), skip bonus validation and proceed directly
    if (useTalon && selectedSubscription) {
      if (
        customer.first_name !== firstName ||
        customer.last_name !== lastName ||
        customer.birthday !== newB
      ) {
        setLoading(true);
        clientsApi.putClient(customer.id, { first_name: firstName, last_name: lastName, birthday: newB, branch_id: info?.id })
          .then((customer) => {
            dispatch({ type: clientInfoTypes.UPDATE_CLIENT_INFO, payload: customer.data });
            setError(false);
            setStep(3);
          })
          .finally(() => {
            setLoading(false);
          })
      } else {
        setError(false);
        setStep(3);
      }
      return;
    }

    // For restricted businesses: require SMS code when withdrawing bonuses or discount order
    if (isSmsCodeBusiness && (isDiscountOrder || bonuses > 0) && !isSendedUseCashbackCode) {
      store.addNotification({
        title: t("send_please_sms_code"),
        message: t("sms_code"),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
      return setError(true);
    }

    if (!isSmsCodeBusiness && customer.send_code_for_use_cashback && (bonuses > 0 || isDiscountOrder) && !isSendedUseCashbackCode) {
      store.addNotification({
        title: t("send_please_whatsapp_code"),
        message: "Whatsapp code",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
      return setError(true);
    }

    if (availableBonusesForWithdraw < bonuses) {
      setError(true);
      return;
    }

    if (parseInt(amount_sum) >= bonuses && amount_sum.length !== 0 && Math.floor(customer.bonuses) >= bonuses) {
      if (
        customer.first_name !== firstName ||
        customer.last_name !== lastName ||
        customer.birthday !== newB
      ) {
        setLoading(true);
        clientsApi.putClient(customer.id, { first_name: firstName, last_name: lastName, birthday: newB, branch_id: info?.id })
          .then((customer) => {
            dispatch({ type: clientInfoTypes.UPDATE_CLIENT_INFO, payload: customer.data });
            setError(false);
            setStep(3);
          })
          .finally(() => {
            setLoading(false);
          })
      } else {
        setError(false);
        setStep(3);
      }
    } else {
      setError(true);
    }
  }

  const sendUseCashback = (e) => {
    e.preventDefault();
    new Promise((resolve, reject) => {
      dispatch(transactionsActions.sendUseCashbackCode(customer.id, info.id, resolve, reject, isDiscountOrder))
    })
  }

  // Изменять error на false если ввели amount_sum
  useEffect(() => {
    if (error && amount_sum) {
      setError(false)
    }
  }, [amount_sum]);

  const renderWhatsAppSendButton = () => {
    // For restricted businesses: show SMS code button when withdrawing bonuses or discount order
    if (isSmsCodeBusiness && (isDiscountOrder || bonuses > 0)) {
      return (
        <div style={{ maxWidth: 485, margin: "0 auto", width: "100%" }}>
          <ButtonFilled onClick={sendUseCashback} loading={isSendUseCashbackCodePending}>
            {t("send_sms_code")}
          </ButtonFilled>
        </div>
      );
    }

    // Original behavior for other businesses
    if (!customer.send_code_for_use_cashback || (bonuses <= 0 && !isDiscountOrder)) return null;

    return (
      <div style={{ maxWidth: 485, margin: "0 auto", width: "100%" }}>
        <ButtonFilled onClick={sendUseCashback} loading={isSendUseCashbackCodePending}>
          {t("send_whatsapp_code")}
        </ButtonFilled>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>{t('NSPayment.assessment')}</p>
        {
          ((!!customer.first_name || !!customer.last_name) && (
            <span>
                    {`${customer.first_name} ${customer.last_name}`} <br/>
                  </span>
          ))
        }
        {
          ((!!customer.gradation_status || customer.gradation_status === '') && (
            <p>{`${customer.gradation_status}`}</p>
          ))
        }
      </div>

      {
        notRegistered && (
          <div className={styles.notRegistered}>
            <p>{'+' + phone} {t('NSBonusModal.notReg')}</p>
            <div>
              <img src={exclaimImg}/>
              <span>{t('NSPayModal.regAuto')}</span>
            </div>
          </div>
        )
      }

      {/*<div className={styles.points}>*/}
      {/*  <p>Количество баллов:</p>*/}
      {/*  <span>{customer.bonuses > 0 ? Math.round(customer.bonuses) : 0}</span>*/}
      {/*</div>*/}

      <div className={styles.getPoints}>
        <p>{t('Form.firstName')}</p>
        <input
          label={t('Form.firstName')}
          placeholder={t('Form.enterFirstName')}
          disabled={pending || cStatus === PENDING}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className={styles.input}
        />
      </div>
      <div className={styles.getPoints}>
        <p>{t('Form.lastName')}</p>
        <input
          label={t('Form.lastName')}
          placeholder={t('Form.enterLastName')}
          disabled={pending || cStatus === PENDING}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          className={styles.input}
          required
        />
      </div>
      <div className={styles.getPoints}>
        <p>{t("NSBonus.birthday")}</p>
        <div class={styles.inputContainer}>
          <CustomSingleDatePicker
            tSetDate={(value) => setBirthday(value)}
            tDate={birthday}
          />
        </div>
      </div>

      {/* Child Birthdays Section */}
      {!notRegistered && (
        <div className={styles.getPoints}>
          <p>Дополнительные дни рождения</p>
          {childBirthdays && childBirthdays.length > 0 ? (
            <div style={{ margin: '0 49px 12px' }}>
              {childBirthdays.map((childBday, index) => {
                const date = new Date(childBday);
                const formattedDate = date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
                return (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '10px 16px',
                      backgroundColor: '#F5F5F5',
                      borderRadius: '8px',
                      marginBottom: '8px',
                    }}
                  >
                    <span style={{ fontSize: '16px', color: '#333' }}>{formattedDate}</span>
                    <button
                      type="button"
                      onClick={() => deleteChildBirthday(childBday)}
                      disabled={childBirthdaysPending}
                      style={{
                        background: '#FF6B6B',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        padding: '6px 12px',
                        fontSize: '14px',
                        cursor: childBirthdaysPending ? 'not-allowed' : 'pointer',
                        opacity: childBirthdaysPending ? 0.6 : 1,
                      }}
                    >
                      Удалить
                    </button>
                  </div>
                );
              })}
            </div>
          ) : (
            <p style={{ margin: '0 49px 12px', color: '#858585', fontSize: '14px' }}>
              Нет сохраненных дополнительных дней рождения
            </p>
          )}

          {!showAddChildBirthday ? (
            <button
              type="button"
              onClick={() => setShowAddChildBirthday(true)}
              className={styles.button}
              style={{ marginBottom: '16px' }}
            >
              + Добавить дополнительные дни рождения
            </button>
          ) : (
            <div style={{ margin: '0 49px 16px', display: 'flex', gap: '12px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
              <div>
                <input
                  type="date"
                  value={newChildBirthday}
                  onChange={(e) => setNewChildBirthday(e.target.value)}
                  max={new Date().toISOString().split('T')[0]}
                  min="1900-01-01"
                  style={{
                    padding: '12px 16px',
                    border: '1px solid #5CC28B',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none',
                  }}
                />
              </div>
              <button
                type="button"
                onClick={() => {
                  if (newChildBirthday) {
                    addChildBirthday(newChildBirthday);
                    setNewChildBirthday('');
                    setShowAddChildBirthday(false);
                  }
                }}
                disabled={!newChildBirthday || childBirthdaysPending}
                style={{
                  background: 'linear-gradient(180deg, #73D389 0%, #4EB78B 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontSize: '16px',
                  cursor: (!newChildBirthday || childBirthdaysPending) ? 'not-allowed' : 'pointer',
                  opacity: (!newChildBirthday || childBirthdaysPending) ? 0.6 : 1,
                }}
              >
                Добавить
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowAddChildBirthday(false);
                  setNewChildBirthday('');
                }}
                style={{
                  background: '#E0E0E0',
                  color: '#333',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontSize: '16px',
                  cursor: 'pointer',
                }}
              >
                Отмена
              </button>
            </div>
          )}
        </div>
      )}

      <div className={styles.getPoints}>
        <p>{t('NSPayment.account')}</p>
        <input
          className={styles.input}
          value={amount_sum}
          onChange={changeAmountSum}
          placeholder="0"
        />
        {!isDiscountOrder && (
          <div className={styles.bonusesAmount}>
            <p>
              {t('NSPayModal.hadBonus', {bonus: customer.bonuses > 0 ? Math.floor(customer.bonuses) : 0})}
            </p>
          </div>
        )}

      </div>

      {/*{*/}
      {/*  type === 'code' && (*/}
      {/*      */}
      {/*  )*/}
      {/*}*/}

      {!useTalon && !isDiscountOrder && (
        <div className={styles.getPoints}>
          <p>{t('NSPayModal.takeBonus')}</p>
          <input
            className={styles.input}
            placeholder="0"
            readOnly={notRegistered}
            value={bonuses}
            onChange={changeBonuses}
            style={error ? {border: '1px solid red'} : {}}
          />
          <div className={styles.bonusesAmount}>
            <p>
              {t('NSPayModal.availableBonus')} &nbsp;
              <span>
                {customer.bonuses ? availableBonusesForWithdraw : 0}
              </span>
            </p>
            {/*<div style={{ textAlign: 'right' }}>*/}
            {/*  <button  style={{ marginBottom: '10px' }} onClick={getHalfOfBonuses}>{t('NSPayModal.take', {percent: '50%'})}</button>*/}
            {/*  <button onClick={getAllBonuses}>{t('NSPayModal.takeAll')}</button>*/}
            {/*</div>*/}
            <div style={{textAlign: 'right'}}>
              <button className={styles.button} style={{marginBottom: '10px'}} onClick={getHalfOfBonuses}>50%</button>
              <button className={styles.button} onClick={getAllBonuses}>100%</button>
            </div>
          </div>
        </div>
      )}

      {renderWhatsAppSendButton()}

      {/* Stamp Subscriptions Section (Талоны) - Hidden when discount order is active */}
      {userSubscriptions && userSubscriptions.length > 0 && !notRegistered && !isDiscountOrder && (
        <div className={styles.getPoints}>
          <p>Талоны</p>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            margin: '0 49px 16px',
            gap: '12px'
          }}>
            <input
              type="checkbox"
              id="useTalonCheckbox"
              checked={useTalon}
              onChange={(e) => {
                setUseTalon(e.target.checked);
                if (!e.target.checked) {
                  setSelectedSubscription(null);
                } else {
                  // Clear bonuses when using talon
                  changeBonuses(0);
                }
              }}
              style={{
                width: '20px',
                height: '20px',
                cursor: 'pointer',
                accentColor: '#4EB78B'
              }}
            />
            <label
              htmlFor="useTalonCheckbox"
              style={{
                fontSize: '18px',
                fontWeight: '500',
                color: '#333333',
                cursor: 'pointer',
                userSelect: 'none'
              }}
            >
              Использовать талон
            </label>
          </div>

          {useTalon && (
            <>
              <select
                className={styles.input}
                value={selectedSubscription ? selectedSubscription.id : ''}
                onChange={(e) => {
                  const subscription = userSubscriptions.find(sub => sub.id === e.target.value);
                  setSelectedSubscription(subscription || null);
                }}
                style={{
                  paddingRight: '32px',
                }}
              >
                <option value="">{'Выберите Талон'}</option>
                {userSubscriptions.map((subscription) => (
                  <option key={subscription.id} value={subscription.id}>
                    {subscription.name} ({subscription.stamps_remaining} из {subscription.total_stamps})
                  </option>
                ))}
              </select>
              {selectedSubscription && (
                <div className={styles.bonusesAmount}>
                  <p>
                    Остаток талонов: {selectedSubscription.stamps_remaining} (из {selectedSubscription.total_stamps})
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {
        !useTalon && info.configuration.access_toggles.tags && info.configuration.access_toggles.tags.enabled && branchTags && branchTags.length > 0 &&
        !(isRestrictedTagBusiness && (!userTags || userTags.length === 0)) && (
          <div className={styles.getPoints}>
            <p style={{ marginBottom: '12px' }}>Тэги</p>

            {/* User's current tags display (read-only) */}
            {userTags && userTags.length > 0 && (
              <div style={{
                margin: '0 49px 16px',
                padding: '16px',
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
              }}>
                <div style={{
                  fontSize: '13px',
                  color: '#666',
                  marginBottom: '10px',
                  fontWeight: '500',
                }}>
                  Текущие теги клиента:
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {userTags.map((tag) => (
                    <div
                      key={tag.id}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '8px 14px',
                        borderRadius: '20px',
                        backgroundColor: tag.background_color || '#e9ecef',
                        color: tag.color || '#333',
                        fontWeight: '500',
                        fontSize: '14px',
                        border: tag.is_discount ? '1px solid #4EB78B' : 'none',
                      }}
                    >
                      {tag.name}
                      <span style={{
                        marginLeft: '8px',
                        padding: '2px 8px',
                        borderRadius: '10px',
                        backgroundColor: 'rgba(0,0,0,0.1)',
                        fontSize: '12px',
                        fontWeight: '600',
                      }}>
                        {tag.bonus_percentage}%
                      </span>
                      {tag.is_discount && (
                        <span style={{
                          marginLeft: '8px',
                          padding: '2px 8px',
                          borderRadius: '10px',
                          backgroundColor: '#4EB78B',
                          color: '#fff',
                          fontSize: '11px',
                          fontWeight: '600',
                        }}>
                          Скидка
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Info message when discount tag is selected */}
            {isDiscountOrder && (
              <div style={{
                margin: '0 49px 16px',
                padding: '12px 16px',
                backgroundColor: '#fff3e0',
                borderRadius: '8px',
                fontSize: '14px',
                color: '#e65100',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}>
                <span style={{ fontSize: '16px' }}>ℹ️</span>
                Выбран скидочный тег - списание бонусов недоступно
              </div>
            )}

            {/* Restricted businesses: only user's existing tags; others: always allow new tag assignment */}
            {isRestrictedTagBusiness ? (
              <div style={{ margin: '0 49px' }}>
                <div style={{
                  fontSize: '13px',
                  color: '#666',
                  marginBottom: '8px',
                  fontWeight: '500',
                }}>
                  Выберите тег для применения:
                </div>
                <select
                  value={selectedUserTagId ? selectedUserTagId.toString() : ''}
                  onChange={(e) => {
                    const tagId = e.target.value || null;
                    setSelectedUserTagId(tagId);
                    setSelectedTag(null); // Clear the other selection

                    // Check if selected tag is a discount tag and set isDiscountOrder
                    if (tagId) {
                      const selectedUserTag = userTags.find(t => t.id.toString() === tagId);
                      if (selectedUserTag && selectedUserTag.is_discount) {
                        setIsDiscountOrder(true);
                      } else {
                        setIsDiscountOrder(false);
                      }
                    } else {
                      setIsDiscountOrder(false);
                    }
                  }}
                  disabled={notRegistered}
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    fontSize: '16px',
                    border: selectedUserTagId ? '2px solid #4EB78B' : '2px solid #e0e0e0',
                    borderRadius: '12px',
                    backgroundColor: '#fff',
                    color: '#333',
                    outline: 'none',
                    cursor: notRegistered ? 'not-allowed' : 'pointer',
                    opacity: notRegistered ? 0.5 : 1,
                    appearance: 'none',
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 12px center',
                    backgroundSize: '20px',
                    transition: 'all 0.2s ease',
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#4EB78B'}
                  onBlur={(e) => e.target.style.borderColor = selectedUserTagId ? '#4EB78B' : '#e0e0e0'}
                >
                  <option value="">Выберите тег</option>
                  {(hasDiscountTag
                    ? userTags.filter(tag => tag.is_discount)
                    : userTags
                  ).map((tag) => (
                    <option
                      key={tag.id}
                      value={tag.id.toString()}
                    >
                      {tag.name} ({tag.bonus_percentage}%){tag.is_discount ? ' - Скидка' : ''}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              /* ALL OTHER BUSINESSES: show user tags + always allow new tag assignment */
              <div style={{ margin: '0 49px' }}>
                {/* Option 1: Select from user's own tags (if they have any) */}
                {userTags && userTags.length > 0 && (
                  <div style={{ marginBottom: '16px' }}>
                    <div style={{
                      fontSize: '13px',
                      color: '#666',
                      marginBottom: '8px',
                      fontWeight: '500',
                    }}>
                      Применить тег клиента:
                    </div>
                    <select
                      value={selectedUserTagId ? selectedUserTagId.toString() : ''}
                      onChange={(e) => {
                        const tagId = e.target.value || null;
                        setSelectedUserTagId(tagId);
                        setSelectedTag(null); // Clear the other selection

                        // Check if selected tag is a discount tag
                        if (tagId) {
                          const selectedUserTag = userTags.find(t => t.id.toString() === tagId);
                          if (selectedUserTag && selectedUserTag.is_discount) {
                            setIsDiscountOrder(true);
                          } else {
                            setIsDiscountOrder(false);
                          }
                        } else {
                          setIsDiscountOrder(false);
                        }
                      }}
                      disabled={notRegistered}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        fontSize: '16px',
                        border: selectedUserTagId ? '2px solid #4EB78B' : '2px solid #e0e0e0',
                        borderRadius: '12px',
                        backgroundColor: selectedUserTagId ? '#f0fff4' : '#fff',
                        color: '#333',
                        outline: 'none',
                        cursor: notRegistered ? 'not-allowed' : 'pointer',
                        opacity: notRegistered ? 0.5 : 1,
                        appearance: 'none',
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 12px center',
                        backgroundSize: '20px',
                        transition: 'all 0.2s ease',
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#4EB78B'}
                      onBlur={(e) => e.target.style.borderColor = selectedUserTagId ? '#4EB78B' : '#e0e0e0'}
                    >
                      <option value="">Выберите тег клиента</option>
                      {userTags.map((tag) => (
                        <option
                          key={tag.id}
                          value={tag.id.toString()}
                        >
                          {tag.name} ({tag.bonus_percentage}%){tag.is_discount ? ' - Скидка' : ''}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Option 2: Assign new tag from available branch tags (excluding user's existing tags) */}
                {(() => {
                  // Filter out tags that user already has
                  const userTagIds = (userTags || []).map(t => t.id.toString());
                  const availableBranchTags = branchTags.filter(t => !userTagIds.includes(t.id.toString()));

                  if (availableBranchTags.length === 0) return null;

                  return (
                    <div>
                      <div style={{
                        fontSize: '13px',
                        color: '#666',
                        marginBottom: '8px',
                        fontWeight: '500',
                      }}>
                        Назначить новый тег:
                      </div>
                      <select
                        value={selectedTag ? selectedTag.toString() : ''}
                        onChange={(e) => {
                          const tagId = e.target.value || null;
                          setSelectedTag(tagId);
                          setSelectedUserTagId(null); // Clear the other selection

                          // Check if selected tag is a discount tag
                          if (tagId) {
                            const selectedBranchTag = branchTags.find(t => t.id.toString() === tagId);
                            if (selectedBranchTag && selectedBranchTag.is_discount) {
                              setIsDiscountOrder(true);
                            } else {
                              setIsDiscountOrder(false);
                            }
                          } else {
                            setIsDiscountOrder(false);
                          }
                        }}
                        style={{
                          width: '100%',
                          padding: '14px 16px',
                          fontSize: '16px',
                          border: selectedTag ? '2px solid #4EB78B' : '2px solid #e0e0e0',
                          borderRadius: '12px',
                          backgroundColor: '#fff',
                          color: '#333',
                          outline: 'none',
                          cursor: 'pointer',
                          appearance: 'none',
                          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'right 12px center',
                          backgroundSize: '20px',
                          transition: 'all 0.2s ease',
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#4EB78B'}
                        onBlur={(e) => e.target.style.borderColor = selectedTag ? '#4EB78B' : '#e0e0e0'}
                      >
                        <option value="">Выберите новый тег</option>
                        {availableBranchTags.map((tag) => (
                          <option
                            key={tag.id}
                            value={tag.id.toString()}
                          >
                            {tag.name} ({tag.bonus_percentage}%){tag.is_discount ? ' - Скидка' : ''}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                })()}
              </div>
            )}
          </div>
        )
      }

      {
        info.configuration.award && info.configuration.access_toggles.awards.enabled && (
          <div className={styles.getPoints}>
            {
              ((notRegistered || customer.received_stamp_count != customer.stamp_count) ||
                (customer.received_stamp_count == 0 && customer.stamp_count == 0)) ? (
                <>
                  <p>{t('NSPayModal.countStamps')}</p>
                  <input
                    className={styles.input}
                    value={stamp_count}
                    onChange={changeStampCount}
                    placeholder="0"
                    disabled={cStatus === PENDING}
                  />
                  <div className={styles.bonusesAmount}>
                    <p>
                      {t('NSPayModal.hadStamps', {
                        hadStamps: customer.received_stamp_count ? customer.received_stamp_count : 0,
                        stampsCount: info.configuration.award.stamp_count
                      })}
                    </p>
                  </div>
                </>
              ) : !customer.award_id && !give_award ? (
                <>
                  <p>{t('NSPayModal.countStamps')}</p>
                  <input
                    className={styles.input}
                    value={stamp_count}
                    onChange={changeStampCount}
                    placeholder="0"
                    disabled={cStatus === PENDING}
                  />
                  <div className={styles.bonusesAmount}>
                    <p>
                      {t('NSPayModal.hadStamps', {hadStamps: 0, stampsCount: info.configuration.award.stamp_count})}
                    </p>
                  </div>
                </>
              ) : null
            }

            {
              (!!+customer.received_stamp_count && !!+customer.stamp_count) &&
              (customer.received_stamp_count == customer.stamp_count) && !give_award && (
                <div className={styles.getPoints}>
                  <p>{t('NSPayModal.countStamps')}</p>
                  <div className={styles.getPoints2}>
                    <p className={styles.getPoints2Counts}>{customer.received_stamp_count} из {customer.stamp_count}</p>
                    <button
                      className={styles.button}
                      onClick={() => setStep(4)}
                    >
                      {t('NSPayModal.givePresent')}
                    </button>
                  </div>
                </div>
              )
            }
          </div>
        )
      }

      <div className={styles.getPoints}>
        <p>{t('comment')}</p>
        <input
          className={styles.input}
          placeholder="N53213"
          value={comment}
          onChange={changeComment}
        />
        <div className={styles.bonusesAmount}>
          <p>
            {t('NSPayModal.exampleNumberCheck')}
          </p>
        </div>
      </div>

      <div className={styles.sendButton}>
        <ButtonFilled
          onClick={nextStep}
          loading={loading}
          disabled={pending}
        >
          {t("send")}
        </ButtonFilled>
      </div>

    </div>
  )
}
